// extracted by mini-css-extract-plugin
module.exports = {"componentWidth":"styles_componentWidth__3NrCm","terminationDateProp":"styles_terminationDateProp__3ygii"};